
import { mapMutations } from 'vuex';
export default {
  name: 'FilterButton',
  props: {
    displayText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '', // schedule || age
    },
  },
  methods: {
    ...mapMutations('search', ['SET_ACTIVE_BOTTOM_DRAWER_FILTER']),
  },
};
